import 'react-datetime/css/react-datetime.css'

import { useRef } from 'react'
import { Button, Form } from 'react-bootstrap'
import Datetime from 'react-datetime'

export const CouponSaveForm = ({ coupon, setCoupon, handleSubmit, onToggleSave, hasFamilyNameWhenLoaded }) => {
  const usersAllowedRef = useRef()

  const handleChange = ({ target }) => {
    setCoupon(prevCoupon => ({
      ...prevCoupon,
      [target.name]: target.value,
    }))
  }

  const handleCountryChange = countryValue => {
    setCoupon(prevCoupon => {
      const currentCountries = Array.isArray(prevCoupon.country) ? prevCoupon.country : [prevCoupon.country || 'all']

      let newCountries
      if (countryValue === 'all') {
        // If 'all' is selected, only keep 'all'
        newCountries = ['all']
      } else {
        // Remove 'all' if it exists and add/remove the specific country
        const filteredCountries = currentCountries.filter(c => c !== 'all')
        if (filteredCountries.includes(countryValue)) {
          // Remove the country
          newCountries = filteredCountries.filter(c => c !== countryValue)
        } else {
          // Add the country
          newCountries = [...filteredCountries, countryValue]
        }

        // If no countries selected, default to 'all'
        if (newCountries.length === 0) {
          newCountries = ['all']
        }
      }

      return {
        ...prevCoupon,
        country: newCountries,
      }
    })
  }

  const handleExpiredChange = date => {
    setCoupon(prevCoupon => ({ ...prevCoupon, expiredAt: date.toDate() }))
  }

  const handleUsersAllowedChange = ev => {
    let usersAllowedArr = usersAllowedRef.current.value.replace(/ /g, ',').split(',')
    if (usersAllowedArr[0] == '') usersAllowedArr = []

    setCoupon(prevCoupon => ({
      ...prevCoupon,
      usersAllowed: usersAllowedArr,
    }))
    ev.target.innerText = 'OK!'
  }

  return (
    <Form style={{ textAlign: 'left' }} onSubmit={handleSubmit}>
      <Form.Group>
        <Form.Label>Code</Form.Label>
        <Form.Control type='text' name='code' value={coupon.code} onChange={handleChange} />
      </Form.Group>

      <Form.Group>
        <Form.Label>Notes</Form.Label>
        <Form.Control type='text' name='notes' value={coupon.notes} onChange={handleChange} />
      </Form.Group>

      <Form.Group>
        <Form.Label>Expiration Date</Form.Label>
        <Datetime value={coupon.expiredAt} onChange={handleExpiredChange} closeOnSelect={true} />
      </Form.Group>

      <Form.Group>
        <Form.Label>Ref User Id (Affilate Partner)</Form.Label>
        <Form.Control type='text' name='refUserId' value={coupon.refUserId} onChange={handleChange} />
      </Form.Group>

      <Form.Group>
        <Form.Label>Family</Form.Label>
        <Form.Control type='text' name='familyName' value={coupon.familyName} onChange={handleChange} disabled={hasFamilyNameWhenLoaded} />
      </Form.Group>

      <Form.Group>
        <Form.Label>Product Category</Form.Label>
        <Form.Control onChange={handleChange} name='productCategory' as='select' value={coupon.productCategory}>
          <option value=''></option>
          <option value='Underwear'>Underwear</option>
          <option value='Pants'>Pants</option>
          <option value='Shirt'>Shirt</option>
          <option value='Skirt'>Skirt</option>
          <option value='Accessorize'>Accessorize</option>
          <option value='Bag'>Bag</option>
          <option value='Jackets'>Jackets</option>
          <option value='Shoes'>Shoes</option>
          <option value='Home Appliances'>Home Appliances</option>
          <option value='Electronic Devices'>Electronic Devices</option>
          <option value='Home Textile'>Home Textile</option>
          <option value='Jewellery'>Jewellery</option>
          <option value='Chips'>Chips & Doritos</option>
          <option value='Waffles'>Waffles & Biscuits</option>
          <option value='Coffee Capsules'>Coffee Capsules</option>
          <option value='Personal Care'>Personal Care</option>
          <option value='Perfumes'>Perfumes</option>
          <option value='Electronic Batteries'>Electronic Devices With Batteries</option>
          <option value='Beauty'>Beauty Creams and Makeup</option>
          <option value='Contact Lenses'>Contact Lenses</option>
        </Form.Control>
      </Form.Group>

      <Form.Group>
        <Form.Label>Limited Uses</Form.Label>
        <Form.Control type='text' name='limitedUses' value={coupon.limitedUses} onChange={handleChange} />
      </Form.Group>

      <Form.Group>
        <Form.Label>Limited Uses For User</Form.Label>
        <Form.Control type='text' name='limitedUsesForUser' value={coupon.limitedUsesForUser} onChange={handleChange} />
      </Form.Group>

      <Form.Group style={{ width: '20%' }}>
        <Form.Label>Type</Form.Label>
        <Form.Control onChange={handleChange} name='type' as='select' value={coupon.type}>
          <option value='PERCENTAGE'>Percentage</option>
          <option value='FIXED'>Fixed</option>
          <option value='MktUniteFee'>Marketplace Unite Fee</option>
          <option value='WarehouseFees'>Warehouse Fees</option>
        </Form.Control>
      </Form.Group>

      <Form.Group>
        <Form.Label>Value ($)</Form.Label>
        <Form.Control type='text' name='value' value={coupon.value} onChange={handleChange} />
      </Form.Group>

      <Form.Group>
        <Form.Label>Users Allowed Ids (id / multiple ids seperated by ",". no spaces, no Quotation mark. blank means everyone)</Form.Label>
        <Form.Control
          type='text'
          name='usersAllowed'
          ref={usersAllowedRef}
          value={coupon.usersAllowed.length > 0 ? coupon.usersAllowed : null}
          onChange={handleChange}
        />
        <Button onClick={ev => handleUsersAllowedChange(ev)}>Add</Button>
      </Form.Group>

      <Form.Group>
        <Form.Label>Minimum Payment (₪)</Form.Label>
        <Form.Control type='text' name='minPayment' value={coupon.minPayment} onChange={handleChange} />
      </Form.Group>

      <Form.Group>
        <Form.Label>Revenue (3% = 0.03)</Form.Label>
        <Form.Control type='text' name='revenue' value={coupon.revenue} onChange={handleChange} />
      </Form.Group>

      <Form.Group>
        <Form.Label>Shipping Method</Form.Label>
        <Form.Control onChange={handleChange} name='shippingMethod' as='select' value={coupon.shippingMethod}>
          <option value='all'>All</option>
          <option value='pickUpPoint'>Pick Up Point</option>
          <option value='doorToDoor'>Door To Door</option>
        </Form.Control>
      </Form.Group>

      <Form.Group>
        <Form.Label>Country</Form.Label>
        <div>
          {['all', 'GR', 'USA', 'UK'].map(country => {
            const currentCountries = Array.isArray(coupon.country) ? coupon.country : [coupon.country || 'all']
            const isChecked = currentCountries.includes(country)
            const countryLabels = {
              all: 'All Countries',
              GR: 'Greece',
              USA: 'USA',
              UK: 'UK',
            }

            return (
              <Form.Check
                key={country}
                type='checkbox'
                id={`country-${country}`}
                label={countryLabels[country]}
                checked={isChecked}
                onChange={() => handleCountryChange(country)}
                style={{ marginBottom: '8px' }}
              />
            )
          })}
        </div>
      </Form.Group>

      <Button type='submit'>Save</Button>
      <Button variant='info' onClick={onToggleSave}>
        Cancel
      </Button>
    </Form>
  )
}
